import styled from 'styled-components';

export const StyledHeaderContainer = styled.span`
	.header-title {
		display: flex;
		gap: 0.25rem;
	}

	.header-icon {
		display: flex;
		align-items: center;
		justify-content: center;
	}
`;

export const StyledMobileImage = styled.img`
	margin-top: 0.5rem;
	height: 100%;
	max-height: 16rem;
	width: 100%;
	object-fit: contain;
`;
